import React from 'react';
import { Input } from '@progress/kendo-react-inputs';

// CHECKPOINT-75: a password input with the label ON TOP and left-aligned, so it
// lines up with the surrounding copy and the rules checklist. Deliberately does
// NOT use the shared form-group Input widget, whose label sits in a narrow left
// column (which made "Temporary password" wrap onto two lines inside the dialog).
const PasswordField = ({ label, value, name, type = 'password', error, onChange, autoComplete = 'new-password' }) => (
    <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontWeight: 600 }}>{label}</label>
        <Input
            value={value}
            name={name}
            type={type}
            autoComplete={autoComplete}
            onChange={onChange}
            style={{ width: '100%', borderColor: error ? '#dc3545' : undefined }}
        />
        {error && <div className="text-danger small" style={{ marginTop: 4 }}>{error}</div>}
    </div>
);

export default PasswordField;
